import * as PropTypes from 'prop-types';

import { URLsManager } from '$app-web/utils';

import useStyles from './styles';

const AuthLayoutWrapper = (props) => {
    const { children, studyBasicInfo } = props;

    const classes = useStyles();

    return (
        <div className={classes.root}>
            <div
                className={classes.background}
                style={{
                    backgroundImage:
                        studyBasicInfo.appBg != null ? `url(${URLsManager.getURLTo(studyBasicInfo.appBg)})` : undefined,
                }}
            />
            {studyBasicInfo.appBg != null && <div className={classes.backgroundOverlay} />}
            {children}
        </div>
    );
};

AuthLayoutWrapper.defaultProps = {
    studyBasicInfo: {},
};

AuthLayoutWrapper.propTypes = {
    children: PropTypes.node.isRequired,
    studyBasicInfo: PropTypes.shape({
        appBg: PropTypes.string,
    }),
};

export default AuthLayoutWrapper;
